// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";

// export default function LinkedEventsPage() {
//   const [orgIds, setOrgIds] = useState([]);
//   const navigate = useNavigate();

  // useEffect(() => {
  //   fetch("https://241hbdvql1.execute-api.ap-south-1.amazonaws.com/praud/orgs")
  //     .then((res) => res.json())
  //     .then((data) => {
  //       const uniqueIds = [...new Set(data)];
  //       setOrgIds(uniqueIds);
  //     })
  //     .catch((err) => console.error("Error fetching orgIds:", err));
  // }, []);

//   return (
//     <div style={styles.container}>
//       {/* Create New Event Button */}
//       <button
//         style={styles.createBtn}
//         onClick={() => navigate("/create-event")}
//       >
//         + Create New Linked Event
//       </button>

//       {/* OrgId Tiles */}
//       <div style={styles.tilesContainer}>
//         {orgIds.length > 0 ? (
//           orgIds.map((id, index) => (
//             <div
//               key={index}
//               style={styles.tile}
//               onClick={() => navigate(`/dashboard/${id}`)} // ✅ navigate with orgId
//             >
//               {id}
//             </div>
//           ))
//         ) : (
//           <p>No OrgIds found</p>
//         )}
//       </div>
//     </div>
//   );
// }

// const styles = {
//   container: { padding: "30px", textAlign: "center" },
//   createBtn: {
//     marginBottom: "20px",
//     padding: "12px 20px",
//     fontSize: "16px",
//     borderRadius: "8px",
//     cursor: "pointer",
//   },
//   tilesContainer: {
//     display: "flex",
//     flexWrap: "wrap",
//     justifyContent: "center",
//     gap: "20px",
//   },
//   tile: {
//     padding: "20px",
//     backgroundColor: "#f0f0f0",
//     borderRadius: "10px",
//     minWidth: "150px",
//     textAlign: "center",
//     cursor: "pointer",
//     fontSize: "18px",
//     fontWeight: "bold",
//     boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
//   },
// };

import React, { useEffect, useState } from "react";
import "./LinkedEventsPage.css"; // Import the CSS file
import { useNavigate } from "react-router-dom";

export default function LinkedEventsPage() {
  const [orgIds, setOrgIds] = useState([]);
  const [loading, setLoading] = useState(true);

  // Simulating navigation for demonstration
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    fetch("https://241hbdvql1.execute-api.ap-south-1.amazonaws.com/praud/orgs")
      .then((res) => res.json())
      .then((data) => {
        const uniqueIds = Array.isArray(data) ? [...new Set(data)] : [];
        setOrgIds(uniqueIds);
      })
      .catch((err) => {
        console.error("Error fetching orgIds:", err);
        setOrgIds([]);
      })
      .finally(() => setLoading(false));
  }, []);

  // --- UI Sub-components ---
  const OrgTile = ({ id }) => (
    <div className="org-tile" onClick={() => navigate(`/dashboard/${id}`)}>
      <div className="tile-icon-wrapper">
        <OrgIcon />
      </div>
      <p className="tile-id">{id}</p>
      <p className="tile-subtext">View Dashboard</p>
    </div>
  );

  const SkeletonLoader = () => (
    <div className="skeleton-tile">
      <div className="skeleton-icon"></div>
      <div className="skeleton-line-1"></div>
      <div className="skeleton-line-2"></div>
    </div>
  );

  const EmptyState = () => (
    <div className="empty-state">
      <OrgIcon />
      <h3 className="empty-state-title">No Organizations Found</h3>
      <p className="empty-state-text">Get started by creating a new linked event.</p>
      <button className="create-btn" onClick={() => navigate("/create-event")}>
        Create an Event
      </button>
    </div>
  );

  // --- Main Component Render ---
  return (
    <div className="page-container">
      <div className="content-wrapper">
        <header className="page-header">
          <div>
            <h1 className="header-title">Linked Events</h1>
            <p className="header-subtitle">Select an organization to view its dashboard.</p>
          </div>
          <button className="create-btn" onClick={() => navigate("/create-event")}>
            <PlusIcon />
            Create New Event
          </button>
        </header>

        <main>
          <div className="tiles-grid">
            {loading ? (
              Array.from({ length: 5 }).map((_, index) => <SkeletonLoader key={index} />)
            ) : orgIds.length > 0 ? (
              orgIds.map((id) => <OrgTile key={id} id={id} />)
            ) : (
              <EmptyState />
            )}
          </div>
        </main>
      </div>
    </div>
  );
}

// --- SVG Icons ---
const OrgIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
  </svg>
);

const PlusIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
    <path fillRule="evenodd" d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" clipRule="evenodd" />
  </svg>
);
